import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';

import Wrapper from '../../elements/wrapper';
import TopBlob from '../../../images/about-top-blob.inline.svg';
import BottomBlob from '../../../images/about-bottom-blob.inline.svg';
import { media } from '../../helpers';

const AboutContentRowsContainer = styled.div`
    .content-row-wrapper {
        max-width: 100vw;
        ${media.large`display: flex;`}

        &.flipped {
            .image-container {
                order: 2;
            }
            .content-container {
                order: 1;
            }
        }

        .image-container {
            flex: 1;
        }
        .content-container {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;

            .inner-wrap {
                max-width: 550px;
                text-align: center;
                padding: 40px 20px;
                position: relative;
                z-index: 10;
                ${media.large`padding: 0;`};

                h3 {
                    font-size: 2rem;
                    color: #fff;
                    margin: 0 0 20px;
                    font-weight: 800;
                    font-family: neue-kabel, sans-serif;
                }

                p,
                div {
                    font-size: 1.1rem;
                    color: #fff;
                    line-height: 1.6;
                }

                a {
                    color: #fff;
                    padding-bottom: 2px;
                    display: inline-block;
                    border-bottom: 1px solid #fff;
                    text-decoration: none;
                    font-size: 1.2rem;
                    font-family: neue-kabel, sans-serif;
                    font-weight: 800;

                    &:hover {
                        opacity: 0.7;
                    }
                }
            }
            .svg-container {
                svg {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;

                    g {
                        mask: none;
                    }
                }
            }
        }
    }
`;
const AboutContentRows = ({ rows, color }) => {
    return (
        <AboutContentRowsContainer>
            {rows &&
                rows.map((row, index) => {
                    const { image, title, bodyContent } = row || {};
                    function generateBody() {
                        return { __html: bodyContent };
                    }
                    const isOdd = (num) => {
                        return num % 2;
                    };
                    return (
                        <Wrapper
                            className={
                                isOdd(index)
                                    ? 'flipped content-row-wrapper'
                                    : 'content-row-wrapper'
                            }
                        >
                            <div className="image-container">
                                <Img
                                    fluid={
                                        image.localFile.childImageSharp.fluid
                                    }
                                />
                            </div>

                            <div
                                className="content-container"
                                style={{ backgroundColor: color }}
                            >
                                <div className="inner-wrap">
                                    <h3>{title}</h3>
                                    <div
                                        className="body"
                                        dangerouslySetInnerHTML={generateBody()}
                                    ></div>
                                </div>
                                <div className="svg-container">
                                    {isOdd(index) ? (
                                        <BottomBlob />
                                    ) : (
                                        <TopBlob />
                                    )}
                                </div>
                            </div>
                        </Wrapper>
                    );
                })}
        </AboutContentRowsContainer>
    );
};

export default AboutContentRows;
